var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b',{staticClass:"contact"},[_vm._v("Contact Infomation")]),_c('hr'),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_vm._v(" Mobile Phone: ")]),_c('div',{staticClass:"col"},[_vm._v(" +1 644841545 ")])])])
}]

export { render, staticRenderFns }